import { ErrorHandler, Injectable, inject } from '@angular/core';
import { NotificationService } from '../services/notification.service';
import {
  ChunkLoadRecoveryDeps,
  isChunkLoadError,
  recoverFromChunkLoadError,
} from './chunk-load-recovery';

@Injectable()
export class ChunkLoadErrorHandler extends ErrorHandler {
  private readonly notificationService = inject(NotificationService);
  private recoveryNotified = false;

  override handleError(error: unknown): void {
    if (isChunkLoadError(error)) {
      this.recoverFromChunkError();
      return;
    }
    super.handleError(error);
  }

  handleNavigationError(error: unknown, targetUrl: string): void {
    if (isChunkLoadError(error)) {
      this.recoverFromChunkError({ targetUrl });
      return;
    }
    super.handleError(error);
  }

  private recoverFromChunkError(
    deps?: Pick<ChunkLoadRecoveryDeps, 'targetUrl'>
  ): void {
    void recoverFromChunkLoadError(deps).then((outcome) => {
      if (this.recoveryNotified) {
        return;
      }
      if (outcome === 'recovering') {
        this.recoveryNotified = true;
        this.notificationService.showInfo('common.app-reloading');
      } else {
        this.recoveryNotified = true;
        this.notificationService.showError(
          'common.app-reload-failed',
          undefined,
          undefined,
          { duration: 7000 }
        );
      }
    });
  }
}
